import React from 'react';

const normalizeAllergens=(allergens)=>{
  if (Array.isArray(allergens)) {
    return allergens
      .map((allergen)=>String(allergen || '').trim())
      .filter(Boolean);
  }

  return String(allergens || '')
    .split(',')
    .map((allergen)=>allergen.trim())
    .filter(Boolean);
};

const AllergenLabels=({allergens})=>{
  const labels=normalizeAllergens(allergens);

  if (!labels.length) return null;

  return (
    <div className="mt-4">
      <p className="mb-2 text-[10px] font-black uppercase tracking-widest text-amber-700">
        Allergen information
      </p>
      <div className="flex flex-wrap gap-2">
        {labels.map((allergen)=>(
          <span
            key={allergen}
            className="rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-[10px] font-black uppercase tracking-wide text-amber-800"
          >
            Contains {allergen}
          </span>
        ))}
      </div>
    </div>
  );
};

export default AllergenLabels;